import { Box, Grid, Skeleton } from '@mui/material'

const InProcessLoansCardSkeleton = () => {

    return (
        <Box sx={{ marginTop: "12px", marginBottom: '1px', paddingInline: "14px" }}>
            <Grid container sx={{ padding: "10px", backgroundColor: "#FFFFFF", width: "100%", border: "1px solid #D7DBEC", borderRadius: "5px", gap: "10px" }}>
                <Grid item sx={{ width: "100%", display: "flex", justifyContent: "start", alignItems: 'center', gap: "10px", borderBottom: "1px solid #D7DBEC" }}>
                    <Box sx={{ height: "70px", width: "70px", display: "flex", alignItems: "center" }}>
                        <Skeleton variant='circular' sx={{ width: "100%", height: "100%", transform: "unset" }} />
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: 'column', alignItems: "start", justifyContent: "center", gap: "5px" }}>
                        <Skeleton variant='rectangular' sx={{ width: "170px", height: "12px", transform: "unset", borderRadius: "10px" }} />
                        <Skeleton variant='rectangular' sx={{ width: "130px", height: "12px", transform: "unset", borderRadius: "10px" }} />
                    </Box>
                </Grid>
                <Grid item sx={{ border: "1px solid #E6E9F4", borderRadius: "5px", width: "100%", display: "flex", flexDirection: "column", gap: "5px" }}>
                    <Skeleton variant='rectangular' sx={{ width: "100%", height: "50px", transform: "unset" }} />
                </Grid>
            </Grid>
        </Box>
    )

}

export default InProcessLoansCardSkeleton